import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-form-service-date',
  templateUrl: './form-service-date.component.html',
  styleUrls: ['./form-service-date.component.css']
})
export class FormServiceDateComponent implements OnInit {

  @Input() list_items: any;

  aux: boolean;

  constructor() { }

  ngOnInit(): void {
    this.aux = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.list_items.currentValue) {
      this.list_items = changes.list_items.currentValue;
      this.list_items.length > 0 ? this.aux = true : this.aux = false;
    }
  }

}
